(function() {
  function init() {
    var root = document.getElementById("crRoot");
    if (!root) {
      return
    }
    var embeddedProduct = null;
    try {
      var pd = document.getElementById("cr7ProductData");
      if (pd) {
        embeddedProduct = normalizeProduct(JSON.parse(pd.textContent || "{}"))
      }
    } catch (e) {
      console.warn("Embedded CreatorOne product data unavailable:", e)
    }
    var state = {
      shape: "Main Desk",
      imageIndex: 0,
      mainProduct: embeddedProduct,
      addonProducts: {},
      addonLoads: {},
      adding: false
    };
    var order = ["Main Desk", "L-Shape", "Extended L-Shape", "U-Shape"];
    var C = "https://cdn.shopify.com/s/files/1/0605/6263/7044/files/",
      galleries = {
        "Main Desk": [C + "0fb3b8a44713d86b25018bc0c9b1897a.jpg?v=1782556577", C + "1_013641be-3261-459e-9675-652a0165dee3.jpg?v=1784716917", C + "2_8151bc31-4b52-4c92-8296-2208ed7a0532.jpg?v=1784716918", C + "3_e8251a70-fa4b-4c92-901a-ed32f5bb9dd3.jpg?v=1784716918", C + "4_6c47e975-dcdd-46c7-8c8d-983f24f2944b.jpg?v=1784716918", C + "5_c5796d62-f5b8-4583-9e9a-dbc280920f19.jpg?v=1784716918", C + "6_5cc76a4c-930e-48d2-a506-5b908ac3b801.jpg?v=1784716918"],
        "L-Shape": [C + "L_81cf30a4-cd46-47cb-a18c-4052e0b398ea.jpg?v=1782556578", C + "L-_2.jpg?v=1784716682", C + "L-_5.jpg?v=1784716683", C + "L-_4.jpg?v=1784716683", C + "L-_3.jpg?v=1784716682", C + "L-_6.jpg?v=1784716681"],
        "Extended L-Shape": [C + "L1.jpg?v=1782556577", C + "L-1.jpg?v=1784717092", C + "L-2.jpg?v=1784717092"],
        "U-Shape": [C + "U.jpg?v=1782556578", C + "U-1.jpg?v=1784717136", C + "U-3.jpg?v=1784717136"]
      };
    var aliases = {
      "Main Desk": ["main desk", "single desk", "cr 1", "cr1"],
      "L-Shape": ["l shape", "l shaped", "cr l"],
      "Extended L-Shape": ["extended l shape", "extended l", "long l shape", "cr l2", "cr l 2"],
      "U-Shape": ["u shape", "u shaped", "cr u"]
    };
    var els = {
      stage: root.querySelector("#cr7Stage"),
      track: root.querySelector("#cr7Track"),
      thumbs: root.querySelector("#cr7Thumbs"),
      shapeButtons: root.querySelectorAll(".cr-shape"),
      addons: root.querySelectorAll(".cr-addon"),
      summary: root.querySelector("#cr7Summary"),
      total: root.querySelector("#cr7Total"),
      add: root.querySelector("#cr7Add"),
      note: root.querySelector("#cr7Note"),
      clear: root.querySelector("#cr7Clear"),
      modal: document.getElementById("cr7Modal"),
      modalImage: document.getElementById("cr7ModalImage"),
      modalTitle: document.getElementById("cr7ModalTitle"),
      modalDesc: document.getElementById("cr7ModalDesc"),
      modalPrice: document.getElementById("cr7ModalPrice")
    };
    var galleryWarmTicket = 0;
    var galleryWarmTimer = 0;
    var summaryMarkup = "";

    function resizedImage(source, width) {
      source = imageUrl(source);
      if (!source) {
        return ""
      }
      try {
        var url = new URL(source, window.location.href);
        var shopifyHost = url.hostname === "cdn.shopify.com" || url.hostname === window.location.hostname || /\.myshopify\.com$/.test(url.hostname);
        if (shopifyHost && /\/(files|products)\//.test(url.pathname)) {
          url.searchParams.set("width", String(width));
          return url.toString();
        }
      } catch (error) {}
      return source;
    }

    function imageSet(source, widths) {
      return widths.map(function(width) {
        return resizedImage(source, width) + " " + width + "w"
      }).join(", ");
    }

    function imageKey(source) {
      try {
        return new URL(source, window.location.href).pathname.split("/").pop()
      } catch (error) {
        return source
      }
    }

    function setSmallImage(image, source) {
      if (!image || !source) {
        return
      }
      image.dataset.fullSrc = source;
      image.loading = "lazy";
      image.decoding = "async";
      image.setAttribute("fetchpriority", "low");
      image.sizes = "42px";
      image.srcset = imageSet(source, [80, 160, 240]);
      image.src = resizedImage(source, 160);
    }

    function clean(value) {
      return String(value || "").trim().toLowerCase().replace(/[-–—_]/g, " ").replace(/[^a-z0-9 ]/g, " ").replace(/\s+/g, " ").trim()
    }

    function containsPhrase(value, phrase) {
      var text = " " + clean(value) + " ";
      var target = " " + clean(phrase) + " ";
      return text.indexOf(target) > -1
    }

    function money(cents) {
      return "$" + (Number(cents || 0) / 100).toFixed(2)
    }

    function productDescription(card) {
      var p = state.addonProducts[card.dataset.key],
        html = p && p.description ? p.description : "";
      if (!html) {
        return "Add this accessory to complete your CreatorOne setup."
      }
      var d = document.createElement("div");
      d.innerHTML = html;
      return (d.textContent || d.innerText || "").replace(/\s+/g, " ").trim() || "Add this accessory to complete your CreatorOne setup."
    }
    var affirmRefreshTimer = null;

    function updateAffirm(amount) {
      var node = root.querySelector("#cr7Affirm");
      if (!node || !amount) {
        return
      }
      node.setAttribute("data-amount", String(Math.max(0, Math.round(amount))));
      clearTimeout(affirmRefreshTimer);
      affirmRefreshTimer = setTimeout(function() {
        var tries = 0;
        (function refresh() {
          if (window.affirm && affirm.ui) {
            if (typeof affirm.ui.ready === "function") {
              affirm.ui.ready(function() {
                if (affirm.ui && typeof affirm.ui.refresh === "function") {
                  affirm.ui.refresh()
                }
              })
            } else if (typeof affirm.ui.refresh === "function") {
              affirm.ui.refresh()
            }
            return
          }
          if (tries++ < 16) {
            setTimeout(refresh, 250)
          }
        })()
      }, 60)
    }

    function indexFor(shape) {
      var index = order.indexOf(shape);
      return index < 0 ? 0 : index
    }

    function gallery() {
      return galleries[state.shape] || galleries["Main Desk"]
    }

    function imageAt(index) {
      var images = gallery();
      return images[(index + images.length) % images.length]
    }

    function syncActiveThumb() {
      requestAnimationFrame(function() {
        var active = els.thumbs && els.thumbs.querySelector(".cr-thumb.is-active");
        if (!active) {
          return
        }
        var left = active.offsetLeft - (els.thumbs.clientWidth - active.offsetWidth) / 2;
        els.thumbs.scrollTo({
          left: Math.max(0, left),
          behavior: "smooth"
        })
      })
    }

    function renderThumbs() {
      if (!els.thumbs) {
        return
      }
      var images = gallery();
      var changed = els.thumbs.dataset.shape !== state.shape;
      if (changed) {
        els.thumbs.dataset.shape = state.shape;
        var fragment = document.createDocumentFragment();
        images.forEach(function(source, index) {
          var button = document.createElement("button");
          button.type = "button";
          button.className = "cr-thumb";
          button.dataset.index = String(index);
          button.setAttribute("aria-label", state.shape + " image " + (index + 1));
          var image = document.createElement("img");
          image.width = 86;
          image.height = 86;
          image.alt = state.shape + " image " + (index + 1);
          image.loading = "lazy";
          image.decoding = "async";
          image.setAttribute("fetchpriority", "low");
          image.sizes = "86px";
          image.srcset = imageSet(source, [120, 180, 260]);
          image.src = resizedImage(source, 180);
          button.appendChild(image);
          fragment.appendChild(button);
        });
        els.thumbs.replaceChildren(fragment);
      }
      els.thumbs.querySelectorAll(".cr-thumb").forEach(function(button) {
        var selected = Number(button.dataset.index) === state.imageIndex;
        button.classList.toggle("is-active", selected);
        button.setAttribute("aria-pressed", String(selected));
      });
      if (changed || els.thumbs.dataset.activeIndex !== String(state.imageIndex)) {
        els.thumbs.dataset.activeIndex = String(state.imageIndex);
        syncActiveThumb();
      }
    }

    function setTrackImage(role, index) {
      var slide = els.track.querySelector('[data-role="' + role + '"]');
      var image = slide && slide.querySelector("img");
      if (!image) {
        return null
      }
      var source = imageAt(index);
      image.alt = state.shape + " image " + ((index + gallery().length) % gallery().length + 1);
      image.loading = "eager";
      image.decoding = "async";
      image.setAttribute("fetchpriority", role === "current" ? "high" : "low");
      if (image.dataset.gallerySource !== source) {
        var serverImage = role === "current" && !image.dataset.gallerySource && image.hasAttribute("srcset") && imageKey(image.getAttribute("src")) === imageKey(source);
        image.dataset.gallerySource = source;
        if (!serverImage) {
          image.sizes = "(max-width:749px) 100vw, (max-width:1200px) 55vw, 800px";
          image.srcset = imageSet(source, [400, 640, 800, 1000, 1400, 1600]);
          image.src = resizedImage(source, 1000);
        }
      }
      return image;
    }

    function prepareAdjacentImages() {
      setTrackImage("prev", state.imageIndex - 1);
      setTrackImage("next", state.imageIndex + 1);
    }

    function loadTrackImages() {
      var ticket = ++galleryWarmTicket;
      clearTimeout(galleryWarmTimer);
      var image = setTrackImage("current", state.imageIndex);
      ["prev", "next"].forEach(function(role) {
        var node = els.track.querySelector('[data-role="' + role + '"] img');
        var expected = imageAt(state.imageIndex + (role === "prev" ? -1 : 1));
        if (node && node.dataset.gallerySource !== expected) {
          node.removeAttribute("srcset");
          node.removeAttribute("src");
          delete node.dataset.gallerySource;
        }
      });
      var connection = navigator.connection;
      if (connection && (connection.saveData || /(^|-)2g$/.test(connection.effectiveType || ""))) {
        return
      }

      function warm() {
        if (ticket !== galleryWarmTicket) {
          return
        }
        galleryWarmTimer = setTimeout(function() {
          if (ticket === galleryWarmTicket && root.isConnected) {
            prepareAdjacentImages()
          }
        }, 200);
      }
      if (image && image.complete && image.naturalWidth) {
        warm()
      } else if (image) {
        image.addEventListener("load", warm, {
          once: true
        });
        image.addEventListener("error", warm, {
          once: true
        });
      }
    }

    function resetTrack() {
      els.track.classList.add("no-transition");
      els.track.style.transition = "none";
      els.track.style.transform = "translate3d(-100%,0,0)";
      loadTrackImages();
      renderThumbs();
      els.track.offsetHeight;
      requestAnimationFrame(function() {
        requestAnimationFrame(function() {
          els.track.style.transition = "";
          els.track.classList.remove("no-transition");
        });
      });
    }

    function animateTrack(position, callback) {
      var finished = false;

      function finish() {
        if (finished) {
          return
        }
        finished = true;
        els.track.removeEventListener("transitionend", finish);
        if (callback) {
          callback()
        }
      }
      els.track.classList.remove("no-transition");
      els.track.style.transition = "";
      els.track.offsetHeight;
      els.track.addEventListener("transitionend", finish);
      els.track.style.transform = "translate3d(" + position + ",0,0)";
      setTimeout(finish, 420)
    }

    function setShape(shape) {
      state.shape = shape;
      state.imageIndex = 0;
      syncMainVariant();
      render();
      resetTrack()
    }

    function variantValues(variant) {
      return [variant.title, variant.option1, variant.option2, variant.option3].filter(Boolean)
    }

    function matchesShape(variant, shape) {
      var shapeAliases = aliases[shape] || [shape];
      var values = variantValues(variant);
      return shapeAliases.some(function(alias) {
        return values.some(function(value) {
          return containsPhrase(value, alias)
        })
      })
    }

    function mainVariant() {
      var product = state.mainProduct;
      if (!product || !product.variants || !product.variants.length) {
        return null
      }
      var found = product.variants.find(function(variant) {
        return matchesShape(variant, state.shape)
      });
      if (found) {
        return found
      }
      if (product.variants.length === 4) {
        return product.variants[indexFor(state.shape)] || null
      }
      return null
    }

    function firstAvailable(product) {
      if (!product || !product.variants || !product.variants.length) {
        return null
      }
      return product.variants.find(function(variant) {
        return variant.available
      }) || product.variants[0]
    }

    function addonVariant(card) {
      var product = state.addonProducts[card.dataset.key];
      var id = card.dataset.variantId;
      if (product && product.variants && product.variants.length) {
        return product.variants.find(function(variant) {
          return String(variant.id) === String(id)
        }) || firstAvailable(product)
      }
      return {
        id: id || "",
        price: Number(card.dataset.activePrice || card.dataset.fallbackPrice || 0),
        title: "Default Title",
        available: true
      }
    }

    function selectedAddons() {
      var rows = [];
      els.addons.forEach(function(card) {
        var input = card.querySelector(".cr-qty input");
        var quantity = Math.max(0, Number(input.value || 0));
        if (quantity <= 0 || card.hidden || card.classList.contains("is-disabled")) {
          return
        }
        var variant = addonVariant(card);
        var price = Number(card.dataset.activePrice || variant.price || card.dataset.fallbackPrice || 0);
        rows.push({
          card: card,
          variant: variant,
          quantity: quantity,
          price: price,
          lineTotal: price * quantity,
          title: card.querySelector(".cr-ai strong").textContent.trim()
        })
      });
      return rows
    }

    function pegboardSelected() {
      var selected = false;
      root.querySelectorAll('[data-key="mainpegboard"],[data-key="extensionpegboard"]').forEach(function(card) {
        if (card.hidden) {
          return
        }
        var input = card.querySelector(".cr-qty input");
        if (input && Number(input.value || 0) > 0) {
          selected = true
        }
      });
      return selected
    }

    function showNote(message) {
      if (!els.note) {
        return
      }
      els.note.textContent = message;
      els.note.hidden = false;
      clearTimeout(els.note.hideTimer);
      els.note.hideTimer = setTimeout(function() {
        els.note.hidden = true
      }, 3500)
    }

    function syncMainVariant() {
      var variant = mainVariant();
      if (!variant) {
        return
      }
      document.querySelectorAll('form[action*="/cart/add"] input[name="id"]').forEach(function(input) {
        input.value = variant.id;
        input.dispatchEvent(new Event("change", {
          bubbles: true
        }))
      });
      try {
        var url = new URL(window.location.href);
        url.searchParams.set("variant", variant.id);
        window.history.replaceState({}, "", url.toString())
      } catch (error) {
        console.warn("Variant URL could not be updated:", error)
      }
    }

    function render() {
      var extension = root.querySelector('[data-key="extensionpegboard"]');
      var removedExtension = false;
      var removedMonitor = false;
      if (extension) {
        var extensionInput = extension.querySelector(".cr-qty input");
        var hideExtension = state.shape === "Main Desk";
        extension.hidden = hideExtension;
        if (hideExtension && Number(extensionInput.value || 0) > 0) {
          extensionInput.value = 0;
          removedExtension = true
        }
      }
      var hasPegboard = pegboardSelected();
      els.addons.forEach(function(card) {
        var input = card.querySelector(".cr-qty input");
        var minus = card.querySelector("[data-minus]");
        var plus = card.querySelector("[data-plus]");
        var requires = card.dataset.requiresPegboard === "true";
        if (card.hidden) {
          card.classList.remove("is-selected");
          input.disabled = true;
          minus.disabled = true;
          plus.disabled = true;
          return
        }
        if (requires && !hasPegboard) {
          if (Number(input.value || 0) > 0) {
            input.value = 0;
            removedMonitor = true
          }
          card.classList.add("is-disabled");
          input.disabled = true;
          minus.disabled = true;
          plus.disabled = true
        } else {
          card.classList.remove("is-disabled");
          input.disabled = false;
          minus.disabled = false;
          plus.disabled = false
        }
      });
      if (removedExtension) {
        showNote("Extension Pegboard Kit is not available for Main Desk and has been removed.")
      } else if (removedMonitor) {
        showNote("Monitor Arm + Slider Rail requires a pegboard and has been removed.")
      }
      els.shapeButtons.forEach(function(button) {
        button.classList.toggle("is-active", button.dataset.shape === state.shape)
      });
      renderThumbs();
      els.addons.forEach(function(card) {
        var quantity = Number(card.querySelector(".cr-qty input").value || 0);
        card.classList.toggle("is-selected", quantity > 0 && !card.hidden && !card.classList.contains("is-disabled"))
      });
      var deskVariant = mainVariant();
      var deskPrice = deskVariant ? Number(deskVariant.price || 0) : 0;
      var rows = selectedAddons();
      var addonsReady = rows.every(function(row) {
        return Boolean(row.variant.id)
      });
      var originalTotal = deskPrice + rows.reduce(function(sum, row) {
        return sum + row.lineTotal
      }, 0);
      var html = '<div class="cr-ds"><div class="cr-line"><div><strong>' + state.shape + '</strong></div><span class="cr-line-prices">' + (deskVariant ? '<b>' + money(deskPrice) + '</b>' : "Loading") + '</span></div></div>';
      if (rows.length) {
        html += '<div class="cr-sh">ADD-ONS</div><div class="cr-ar">';
        rows.forEach(function(row) {
          var special = row.card.dataset.key === "monitorrail";
          var v = row.variant.title && row.variant.title !== "Default Title" ? row.variant.title : "";
          html += '<div class="cr-line"><div><strong>' + row.title + (special ? '' : '<span class="cr-iq"> x ' + row.quantity + '</span>') + '</strong>' + (special ? '<em>' + (v ? v + ' · ' : '') + 'x ' + row.quantity + '</em>' : '') + '</div><span>' + money(row.lineTotal) + '</span></div>'
        });
        html += '</div>'
      }
      html += '<div class="cr-ts' + (rows.length ? '' : ' no-addons') + '"><div class="cr-tr"><span>Subtotal</span><span>' + (deskVariant ? money(originalTotal) : 'Loading') + '</span></div><div class="cr-tr is-total"><span>Total</span><span>' + (deskVariant ? money(originalTotal) : 'Loading') + '</span></div><p id="cr7Affirm" class="cr-affirm affirm-as-low-as" data-page-type="product" data-amount="' + (deskVariant ? originalTotal : 0) + '"></p></div>';
      if (summaryMarkup !== html) {
        summaryMarkup = html;
        els.summary.innerHTML = html;
        if (deskVariant) {
          updateAffirm(originalTotal)
        }
      }
      els.total.textContent = deskVariant ? money(originalTotal) : "Loading";
      if (els.clear) {
        els.clear.disabled = !rows.length
      }
      els.add.disabled = !deskVariant || !deskVariant.available || !addonsReady || state.adding;
      if (state.adding) {
        els.add.textContent = "Adding..."
      } else if (!deskVariant) {
        els.add.textContent = "Loading desk..."
      } else if (!addonsReady) {
        els.add.textContent = "Loading add-ons..."
      } else {
        els.add.textContent = "Add to cart"
      }
    }

    function imageUrl(image) {
      if (!image) {
        return ""
      }
      if (typeof image === "string") {
        return image.indexOf("//") === 0 ? "https:" + image : image
      }
      var source = image.src || image.url || "";
      return source.indexOf("//") === 0 ? "https:" + source : source
    }

    function hydrateAddon(card, product) {
      state.addonProducts[card.dataset.key] = product;
      if (!product || !product.variants || !product.variants.length) {
        return
      }
      var variant = firstAvailable(product);
      var select = card.querySelector(".cr-av");
      var image = card.querySelector(".cr-addon-image");
      card.dataset.variantId = variant ? variant.id : "";
      var productImage = imageUrl(product.featured_image);
      if (productImage && image && card.dataset.lockImage !== "true") {
        setSmallImage(image, productImage)
      }
      select.innerHTML = "";
      if (product.variants.length > 1) {
        card.classList.add("has-variants");
        product.variants.forEach(function(item) {
          var option = document.createElement("option");
          option.value = item.id;
          option.dataset.price = item.price;
          option.textContent = item.title + " - " + money(item.price) + (item.available ? "" : " (Sold out)");
          option.disabled = !item.available;
          select.appendChild(option)
        });
        if (variant) {
          select.value = variant.id
        }
      } else {
        card.classList.remove("has-variants")
      }
      if (variant) {
        card.dataset.activePrice = variant.price;
        card.querySelector(".cr-ap").textContent = money(variant.price)
      }
      render()
    }

    function normalizeProduct(product) {
      if (product && product.product) {
        product = product.product
      }
      if (!product || !product.variants || !product.variants.length) {
        return null
      }
      product.variants = product.variants.map(function(variant) {
        variant.title = variant.title || variant.public_title || variant.name || variant.option1 || "";
        variant.option1 = variant.option1 || variant.public_title || variant.name || variant.title || "";
        if (typeof variant.available === "undefined") {
          variant.available = true
        }
        return variant
      });
      return product
    }

    function findEmbeddedProduct(handle) {
      var candidates = [];
      if (window.meta && window.meta.product) {
        candidates.push(window.meta.product)
      }
      if (window.ShopifyAnalytics && ShopifyAnalytics.meta && ShopifyAnalytics.meta.product) {
        candidates.push(ShopifyAnalytics.meta.product)
      }
      document.querySelectorAll('script[type="application/json"]').forEach(function(script) {
        try {
          var data = JSON.parse(script.textContent || "");
          if (data && data.product) {
            candidates.push(data.product)
          } else if (data && data.variants) {
            candidates.push(data)
          }
        } catch (error) {}
      });
      for (var i = 0; i < candidates.length; i += 1) {
        var product = normalizeProduct(candidates[i]);
        if (product && (!product.handle || product.handle === handle || window.location.pathname.indexOf("/products/" + handle) > -1)) {
          return product
        }
      }
      return null
    }

    function productFromHtml(text, handle) {
      var page = new DOMParser().parseFromString(text, "text/html");
      var form = page.querySelector('form[action*="/cart/add"]');
      var input = form ? form.querySelector('[name="id"]') : null;
      if (!input || !input.value) {
        return null
      }
      var price = 0;
      var priceMeta = page.querySelector('meta[property="product:price:amount"]');
      if (priceMeta && priceMeta.content) {
        price = Math.round(Number(priceMeta.content) * 100)
      }
      if (!price) {
        var priceNode = page.querySelector('[data-product-price],.price-item--sale,.price-item--regular');
        var match = priceNode ? priceNode.textContent.replace(/,/g, "").match(/[0-9]+(?:\.[0-9]{1,2})?/) : null;
        if (match) {
          price = Math.round(Number(match[0]) * 100)
        }
      }
      var desc = page.querySelector(".product__description,[data-product-description],.product-single__description");
      return {
        handle: handle,
        featured_image: "",
        description: desc ? desc.innerHTML : "",
        variants: [{
          id: Number(input.value),
          title: "Default Title",
          option1: "Default Title",
          price: price,
          available: !input.disabled
        }]
      }
    }

    function fetchProduct(handle) {
      if (handle === "creatorone") {
        var embedded = findEmbeddedProduct(handle);
        if (embedded) {
          return Promise.resolve(embedded)
        }
      }
      var route = window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : "/";
      if (route.charAt(route.length - 1) !== "/") {
        route += "/"
      }
      var urls = [];
      if (window.location.pathname.indexOf("/products/" + handle) > -1) {
        urls.push(window.location.pathname.replace(/\/$/, "") + ".js")
      }
      urls.push(route + "products/" + handle + ".js");
      urls.push("/products/" + handle + ".js");
      urls.push("/products/" + handle + ".js?country=US");
      urls.push(route + "products/" + handle + ".json");
      urls.push("/products/" + handle + ".json");
      urls = urls.filter(function(url, index) {
        return urls.indexOf(url) === index
      });
      var index = 0;

      function next() {
        if (index >= urls.length) {
          return fetch(route + "products/" + handle, {
            credentials: "same-origin"
          }).then(function(response) {
            if (!response.ok) {
              throw new Error("Unable to load " + handle)
            }
            return response.text()
          }).then(function(text) {
            var product = productFromHtml(text, handle);
            if (!product) {
              throw new Error("Unable to read " + handle)
            }
            return product
          })
        }
        var url = urls[index++];
        return fetch(url, {
          credentials: "same-origin",
          headers: {
            Accept: "application/json"
          }
        }).then(function(response) {
          if (!response.ok) {
            throw new Error(response.status + " " + url)
          }
          return response.text()
        }).then(function(text) {
          var product = normalizeProduct(JSON.parse(text));
          if (!product) {
            throw new Error("Invalid product data " + url)
          }
          return product
        }).catch(next)
      }
      return next()
    }

    function ensureAddon(card) {
      var key = card.dataset.key;
      if (state.addonProducts[key] && card.dataset.variantId) {
        return Promise.resolve()
      }
      if (state.addonLoads[key]) {
        return state.addonLoads[key]
      }
      state.addonLoads[key] = fetchProduct(card.dataset.handle).then(function(product) {
        hydrateAddon(card, product)
      }).finally(function() {
        delete state.addonLoads[key]
      });
      return state.addonLoads[key]
    }

    function openModal(card) {
      if (!els.modal || card.hidden) {
        return
      }
      if (!state.addonProducts[card.dataset.key]) {
        ensureAddon(card).then(function() {
          openModalReady(card)
        }).catch(function() {
          openModalReady(card)
        });
        return
      }
      openModalReady(card)
    }

    function openModalReady(card) {
      var title = card.querySelector(".cr-ai strong").textContent.trim();
      var thumb = card.querySelector(".cr-addon-image");
      var image = thumb.dataset.fullSrc || thumb.src;
      var variant = addonVariant(card);
      els.modalImage.decoding = "async";
      els.modalImage.loading = "eager";
      els.modalImage.sizes = "(max-width:760px) calc(100vw - 40px), 600px";
      els.modalImage.srcset = imageSet(image, [400, 800, 1200, 1600]);
      els.modalImage.src = resizedImage(image, 1200);
      els.modalImage.alt = title;
      els.modalTitle.textContent = title;
      els.modalDesc.textContent = productDescription(card);
      els.modalPrice.textContent = money(Number(card.dataset.activePrice || variant.price || card.dataset.fallbackPrice || 0));
      els.modal.hidden = false;
      document.documentElement.classList.add("cr-modal-open")
    }

    function closeModal() {
      if (!els.modal) {
        return
      }
      els.modal.hidden = true;
      document.documentElement.classList.remove("cr-modal-open")
    }
    els.shapeButtons.forEach(function(button) {
      button.addEventListener("click", function() {
        setShape(button.dataset.shape)
      })
    });
    els.thumbs.addEventListener("click", function(event) {
      var button = event.target.closest(".cr-thumb");
      if (!button) {
        return
      }
      state.imageIndex = Number(button.dataset.index || 0);
      resetTrack()
    });
    els.addons.forEach(function(card) {
      var select = card.querySelector(".cr-av");
      var minus = card.querySelector("[data-minus]");
      var plus = card.querySelector("[data-plus]");
      var input = card.querySelector(".cr-qty input");
      card.setAttribute("role", "button");
      card.setAttribute("tabindex", "0");
      card.addEventListener("click", function(event) {
        if (event.target.closest(".cr-qty") || event.target.closest(".cr-av")) {
          return
        }
        openModal(card)
      });
      card.addEventListener("keydown", function(event) {
        if (event.key !== "Enter" && event.key !== " ") {
          return
        }
        event.preventDefault();
        openModal(card)
      });
      select.addEventListener("click", function(event) {
        event.stopPropagation()
      });
      select.addEventListener("change", function() {
        card.dataset.variantId = select.value;
        var option = select.options[select.selectedIndex];
        if (option && option.dataset.price) {
          card.dataset.activePrice = option.dataset.price;
          card.querySelector(".cr-ap").textContent = money(option.dataset.price)
        }
        render()
      });
      minus.addEventListener("click", function(event) {
        event.stopPropagation();
        input.value = Math.max(0, Number(input.value || 0) - 1);
        render()
      });
      plus.addEventListener("click", function(event) {
        event.stopPropagation();
        if (card.dataset.requiresPegboard === "true" && !pegboardSelected()) {
          showNote("Select Main Metal Pegboard or Extension Pegboard Kit first.");
          return
        }
        input.value = Math.max(0, Number(input.value || 0) + 1);
        if (card.dataset.key === "mainpegboard" || card.dataset.key === "extensionpegboard") {
          var monitor = root.querySelector('[data-key="monitorrail"]');
          if (monitor) {
            var monitorInput = monitor.querySelector(".cr-qty input");
            var monitorMinus = monitor.querySelector("[data-minus]");
            var monitorPlus = monitor.querySelector("[data-plus]");
            monitor.classList.remove("is-disabled");
            monitorInput.disabled = false;
            monitorMinus.disabled = false;
            monitorPlus.disabled = false
          }
        }
        render();
        if (!card.dataset.variantId) {
          ensureAddon(card).then(render).catch(function(error) {
            console.error("Accessory could not be loaded:", card.dataset.handle, error);
            render()
          })
        }
      });
      input.addEventListener("click", function(event) {
        event.stopPropagation()
      });
      input.addEventListener("input", function() {
        if (input.value === "" || Number(input.value) < 0) {
          input.value = 0
        }
        render()
      })
    });
    if (els.modal) {
      els.modal.querySelectorAll("[data-modal-close]").forEach(function(button) {
        button.addEventListener("click", closeModal)
      });
      document.addEventListener("keydown", function(event) {
        if (event.key === "Escape" && !els.modal.hidden) {
          closeModal()
        }
      })
    }
    if (els.clear) {
      els.clear.addEventListener("click", function() {
        els.addons.forEach(function(card) {
          var input = card.querySelector(".cr-qty input");
          if (input) {
            input.value = 0
          }
        });
        render()
      })
    }
    els.add.addEventListener("click", function() {
      if (state.adding) {
        return
      }
      var deskVariant = mainVariant();
      var rows = selectedAddons();
      if (!deskVariant) {
        showNote("The selected desk configuration is still loading.");
        return
      }
      if (!rows.every(function(row) {
          return Boolean(row.variant.id)
        })) {
        showNote("The selected add-ons are still loading.");
        return
      }
      var items = [{
        id: Number(deskVariant.id),
        quantity: 1,
        properties: {
          "Desk Type": state.shape
        }
      }];
      rows.forEach(function(row) {
        items.push({
          id: Number(row.variant.id),
          quantity: row.quantity,
          properties: {
            "Add-on for": state.shape
          }
        })
      });
      state.adding = true;
      render();
      fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json"
        },
        body: JSON.stringify({
          items: items
        })
      }).then(function(response) {
        if (!response.ok) {
          return response.json().catch(function() {
            return {
              description: "Add to cart failed"
            }
          }).then(function(error) {
            throw new Error(error.description || error.message || "Add to cart failed")
          })
        }
        return response.json()
      }).then(function() {
        document.dispatchEvent(new CustomEvent("cart:refresh", {
          bubbles: true
        }));
        document.dispatchEvent(new CustomEvent("cart:change", {
          bubbles: true
        }));
        setTimeout(function() {
          var drawer = document.querySelector("cart-drawer");
          var trigger = document.querySelector('[aria-controls="cart-drawer"]');
          if (drawer && typeof drawer.show === "function") {
            drawer.show()
          } else if (trigger) {
            trigger.click()
          } else {
            window.location.href = "/cart"
          }
        }, 80)
      }).catch(function(error) {
        console.error(error);
        alert(error.message || "This configuration could not be added. Please try again.")
      }).finally(function() {
        state.adding = false;
        render()
      })
    });
    (function mobileBottomBar() {
      var bar = root.querySelector(".cr-bottom");
      if (!bar) {
        return
      }

      function update() {
        if (window.innerWidth > 749) {
          bar.classList.remove("is-mobile-fixed");
          return
        }
        var rect = root.getBoundingClientRect();
        var height = bar.offsetHeight || 74;
        bar.classList.toggle("is-mobile-fixed", rect.top < window.innerHeight - height && rect.bottom > window.innerHeight)
      }
      var queued = false;

      function schedule() {
        if (queued) {
          return
        }
        queued = true;
        requestAnimationFrame(function() {
          queued = false;
          update()
        })
      }
      window.addEventListener("scroll", schedule, {
        passive: true
      });
      window.addEventListener("resize", schedule);
      update()
    })();
    (function enableSwipe() {
      var active = false;
      var dragging = false;
      var startX = 0;
      var startY = 0;
      els.stage.addEventListener("pointerdown", function(event) {
        if (event.button && event.button !== 0) {
          return
        }
        prepareAdjacentImages();
        active = true;
        dragging = false;
        startX = event.clientX;
        startY = event.clientY;
        els.stage.classList.add("is-dragging")
      });
      els.stage.addEventListener("pointermove", function(event) {
        if (!active) {
          return
        }
        var deltaX = event.clientX - startX;
        var deltaY = event.clientY - startY;
        if (!dragging) {
          if (Math.abs(deltaX) < 8 && Math.abs(deltaY) < 8) {
            return
          }
          dragging = Math.abs(deltaX) > 1.1 * Math.abs(deltaY)
        }
        if (dragging) {
          event.preventDefault();
          els.track.classList.add("no-transition");
          els.track.style.transform = "translate3d(calc(-100% + " + deltaX + "px),0,0)"
        }
      });
      els.stage.addEventListener("pointerup", function(event) {
        if (!active) {
          return
        }
        var deltaX = event.clientX - startX;
        var deltaY = event.clientY - startY;
        var threshold = Math.min(140, els.stage.clientWidth * .16);
        if (Math.abs(deltaX) > 1.1 * Math.abs(deltaY) && Math.abs(deltaX) >= threshold) {
          if (deltaX < 0) {
            animateTrack("-200%", function() {
              state.imageIndex = (state.imageIndex + 1) % gallery().length;
              resetTrack()
            })
          } else {
            animateTrack("0%", function() {
              state.imageIndex = (state.imageIndex - 1 + gallery().length) % gallery().length;
              resetTrack()
            })
          }
        } else {
          animateTrack("-100%", resetTrack)
        }
        active = false;
        dragging = false;
        els.stage.classList.remove("is-dragging")
      });
      els.stage.addEventListener("pointercancel", function() {
        if (active) {
          animateTrack("-100%", resetTrack)
        }
        active = false;
        dragging = false;
        els.stage.classList.remove("is-dragging")
      })
    })();
    resetTrack();
    render();
    if (state.mainProduct) {
      syncMainVariant();
      render()
    } else {
      fetchProduct("creatorone").then(function(product) {
        state.mainProduct = product;
        syncMainVariant();
        render()
      }, function(error) {
        console.error("CreatorOne product fallback request failed:", error);
        render()
      })
    }
    els.addons.forEach(function(card) {
      ensureAddon(card).catch(function(error) {
        console.error("Accessory could not be loaded:", card.dataset.handle, error);
        render()
      })
    })
  }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init)
  } else {
    init()
  }
})();
(() => {
  const r = document.getElementById('livtab-creatorone-intro');
  if (!r || r.dataset.ready) return;
  r.dataset.ready = 'true';
  const reduce = matchMedia('(prefers-reduced-motion:reduce)').matches;

  function play(v) {
    if (v.closest('[hidden]')) return;
    if (v.dataset.src) {
      v.src = v.dataset.src;
      delete v.dataset.src
    }
    if (!reduce) v.play().catch(() => {})
  }
  const io = new IntersectionObserver(es => es.forEach(e => {
    if (e.isIntersecting) play(e.target);
    else e.target.pause()
  }), {
    rootMargin: '160px'
  });
  r.querySelectorAll('video').forEach(v => io.observe(v));
  r.querySelectorAll('.co-tabs-module').forEach(m => {
    const bs = [...m.querySelectorAll('[role=tab]')],
      ps = [...m.querySelectorAll('[role=tabpanel]')];
    let request = 0;

    function select(i) {
      const ticket = ++request;
      bs.forEach((b, j) => {
        b.setAttribute('aria-selected', i === j);
        b.tabIndex = i === j ? 0 : -1;
        ps[j].hidden = i !== j;
        ps[j].querySelectorAll('video').forEach(v => {
          v.pause();
          if (i === j) {
            if (v.dataset.src) {
              v.src = v.dataset.src;
              delete v.dataset.src
            }
            const reset = () => {
              if (ticket !== request || ps[j].hidden) return;
              try {
                v.currentTime = 0
              } catch (_) {}
            };
            reset();
            if (!v.readyState) v.addEventListener('loadedmetadata', reset, {
              once: true
            });
            v.play().catch(() => {})
          }
        })
      })
    }
    bs.forEach((b, i) => {
      b.addEventListener('click', () => select(i));
      b.addEventListener('keydown', e => {
        let n = i;
        if (e.key === 'ArrowRight') n = (i + 1) % bs.length;
        else if (e.key === 'ArrowLeft') n = (i + bs.length - 1) % bs.length;
        else if (e.key === 'Home') n = 0;
        else if (e.key === 'End') n = bs.length - 1;
        else return;
        e.preventDefault();
        select(n);
        bs[n].focus()
      })
    })
  });
})();;
(() => {
  const root = document.getElementById('crRoot');
  if (!root) return;
  root.querySelectorAll('.cr-rating').forEach(link => link.addEventListener('click', event => {
    const target = document.querySelector('#judgeme_product_reviews') || document.querySelector('.jdgm-review-widget') || document.querySelector('[data-widget-name="review_widget"]');
    if (!target) return;
    event.preventDefault();
    target.scrollIntoView({
      behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
      block: 'start'
    });
    if (!target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1');
    target.focus({
      preventScroll: true
    });
  }));
})();
